import { signal } from '@angular/core';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';
import { TwcLegendComponent } from '../../../twc-legend/twc-legend.component';
import { PrecipitationSvgComponent } from './precipitation-svg/precipitation-legend-svg';

export const PRECIPITATION_LEGEND: TwcLegendParams = {
  title: 'PRECIPITATION',
  legendTitleBarInfo: signal('0'),
  data: { svgComponent: PrecipitationSvgComponent },
  legendComponent: TwcLegendComponent
};
